import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import './DisclaimersSection.scss'


function DisclaimerTextRender({ diList }) {
    function DisclaimerTextEntry({ text, fontSize, fontWeight, fontStyle }) {
        return (<div style={{ fontSize: fontSize, fontWeight: fontWeight, fontStyle: fontStyle }}>
            {text}
        </div>);
    }
    // 9 arrays map to 9 boxes
    let txtScrubbed = [[], [], [], [], [], [], [], [], []];
    let txtRendered = [[], [], [], [], [], [], [], [], []];
    // normalize data fields
    for (var i = 0; i < diList.length; i++) {
        let di = diList[i];

        di.fontWeight = (di.bold) ? "bold" : "";
        di.fontSize = (Number.parseInt(di.size, 10) || 12);
        di.fontStyle = (di.italic) ? "italic" : "";

        let outI = Number.parseInt(di.box, 10) || 0;

        if (outI > 10 || outI < 0) { outI = 0; }
        txtScrubbed[outI].push(di);
    }

    for (var i = 0; i < txtRendered.length; i++) {
        txtRendered[i] = txtScrubbed[i].map((props, index) =>
            <DisclaimerTextEntry key={index + "DisclaimerTextEntry"}  text={props.text} fontSize={props.fontSize} fontWeight={props.fontWeight} fontStyle={props.fontStyle} />
        );
    }

    return (
        <div>
            <div>
                <section className="layout1">
                    <div className="header1">{txtRendered[0]}</div>
                    <div className="leftSide1"></div>
                    <div className="body1">{txtRendered[1]}</div>
                    <div className="rightSide1"></div>
                    <div className="footer1">{txtRendered[2]}</div>
                </section>
                <section className="layout2">
                    <div className="grow2">{txtRendered[3]}</div>
                    <div className="grow2">{txtRendered[4]}</div>
                    <div className="grow2">{txtRendered[5]}</div>
                </section>
                <section className="layout2">
                    <div ></div>
                    <div className="grow2">{txtRendered[6]}</div>
                    <div className="grow2">{txtRendered[7]}</div>
                </section>
                <section className="layout2">
                    <div></div>
                    <div></div>
                    <div className="grow2">{txtRendered[8]}</div>
                </section>
            </div>
        </div>
    );
}


function ContactListRender({ props }) {

    const titleText = props.title || "";
    const headerRows = props.Headers.map((text) => <th><span>{text}</span></th>);
    const bodyRows = props.text.map((textLine) => <tr> {textLine.map((textRow) => <td>{textRow}</td>)} </tr>);

    return (
        <div>
            <div>{titleText}</div>
            <table className="tableizer-table">
                <thead><tr className="tableizer-firstrow">{headerRows}</tr></thead>
                <tbody>
                    {bodyRows}
                </tbody>
            </table>
        </div>
    );
}

export const ContactListSection = () => {

    const { dbFormSpec } = useContext(ConfigContext);
    if (dbFormSpec) {
        if (dbFormSpec.CustomContactList) {
            return (
                <div id="CustomContactText">
                    <ContactListRender props={dbFormSpec.CustomContactList} />
                </div>
            );
        }
    }

    return (
        <>
        </>
    );
};



export const DisclaimersSection = () => {
    const { dbFormSpec } = useContext(ConfigContext);
    if (dbFormSpec) {
        if (dbFormSpec.CustomDisclaimerText) {
            return (
                <div id="CustomDisclaimerText">
                    <DisclaimerTextRender diList={dbFormSpec.CustomDisclaimerText} />
                </div>
            );
        }
    }

    return (
        <>
        </>
    );
};



